import { render, staticRenderFns } from "./ResellerViewLogs.vue?vue&type=template&id=1d164d06"
import script from "./ResellerViewLogs.vue?vue&type=script&lang=js"
export * from "./ResellerViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports